import isEmpty from "lodash/isEmpty"
import each from "lodash/each"
import isArray from "lodash/isArray"
import get from "lodash/get"
import findIndex from "lodash/findIndex"
import map from "lodash/map"
import uniqBy from "lodash/uniqBy"
import {
  GET_LINKED_ACCOUNTS_PENDING,
  GET_LINKED_ACCOUNTS_FAILED,
  GET_LINKED_ACCOUNTS_FULFILLED,
  GET_CUSTOMER_ACCOUNT_BY_EMAIL_PENDING,
  GET_CUSTOMER_ACCOUNT_BY_EMAIL_FAILED,
  GET_CUSTOMER_ACCOUNT_BY_EMAIL_FULFILLED,
  SET_LINKED_ACCOUNTS_PENDING,
  SET_LINKED_ACCOUNTS_FAILED,
  SET_LINKED_ACCOUNTS_FULFILLED,
  SET_MULTIACCOUNT_LINK_PENDING,
  SET_MULTIACCOUNT_LINK_FAILED,
  SET_MULTIACCOUNT_LINK_FULFILLED,
  SET_UNLINKED_ACCOUNTS_PENDING,
  SET_UNLINKED_ACCOUNTS_FAILED,
  SET_UNLINKED_ACCOUNTS_FULFILLED,
  HIDE_MANAGE_ACCOUNT_MESSAGE,
  UPDATE_LINKED_ACCOUNTS_FULFILLED,
  GET_USER_PAYMENT_STATUS_PENDING,
  GET_USER_PAYMENT_STATUS_FAILED,
  GET_USER_PAYMENT_STATUS_FULFILLED,
  RESET_DASHBOARD_FROM_GETTING_STARTED,
  RESET_USER_ACCOUNT,
  SET_CONTACT_UPDATE_PENDING,
  SET_CONTACT_UPDATE_FAILED,
  SET_CONTACT_UPDATE_FULFILLED,
  CLEAR_FIRST_TIME_USER,
  CLEAR_DASHBOARD_TOUR,
  SET_DASHBOARD_TYPE,
} from "constants-lib/actionTypes"

const initialState = {
  getLinkedAccountStatus: ``,
  linkedAccounts: [],
  pendingAccounts: [],
  multiAccountErrors: {},
  getUnlinkedAccountStatus: ``,
  unlinkedAccounts: [],
  setLinkAccountState: ``,
  setLinkAccountStateMessage: ``,
  setMultiAccountLinkState: ``,
  setMultiAccountLinkStateMessage: ``,
  setUnLinkAccountStateMessage: ``,
  updateNickNameState: ``,
  userAccountDetails: [],
  userAccountStatus: ``,
  contactUpdate: false,
  contactUpdateStatus: ``,
  eligibleDashboardTour: [],
  eligibleTours: {
    residential: false,
    commercial: false,
    rolloff: false,
    selector: false,
  },
  actualResponse: {},
  useNewDashboard: false,
  numPendingAccounts: 0,
}

export default (state = initialState, action = {}) => {
  let dedupedAccounts = []
  let dedupedPendingAccounts = []

  switch (action.type) {
    case GET_LINKED_ACCOUNTS_PENDING:
      return {
        ...state,
        getLinkedAccountStatus: `pending`,
      }

    case GET_LINKED_ACCOUNTS_FAILED:
      return {
        ...state,
        getLinkedAccountStatus: `failed`,
      }

    case GET_LINKED_ACCOUNTS_FULFILLED:
      dedupedAccounts = dedupeAndMergeAccounts(dedupedAccounts, action, state)

      return {
        ...state,
        contactUpdate: action.payload.contactUpdate,
        eligibleDashboardTour: action.payload.eligibleDashboardTour,
        eligibleTours: action.payload.eligibleTours,
        linkedAccounts: dedupedAccounts,
        pendingAccounts: action.payload.pendingAccounts,
        getLinkedAccountStatus: `fulfilled`,
        setLinkAccountState: ``,
        setLinkAccountStateMessage: ``,
        setMultiAccountLinkState: ``,
        setMultiAccountLinkStateMessage: ``,
        multiAccountErrors: {},
        setUnLinkAccountStateMessage: ``,
        numPendingAccounts: 0,
      }

    case GET_CUSTOMER_ACCOUNT_BY_EMAIL_PENDING:
      return {
        ...state,
        getUnlinkedAccountStatus: `pending`,
      }

    case GET_CUSTOMER_ACCOUNT_BY_EMAIL_FAILED:
      return {
        ...state,
        getUnlinkedAccountStatus: `failed`,
      }

    case GET_CUSTOMER_ACCOUNT_BY_EMAIL_FULFILLED:
      return {
        ...state,
        unlinkedAccounts: action.payload,
        getUnlinkedAccountStatus: `fulfilled`,
      }

    case SET_LINKED_ACCOUNTS_PENDING:
      return {
        ...state,
        setLinkAccountState: `pending`,
        setUnLinkAccountStateMessage: ``,
        setLinkAccountStateMessage: ``,
        errorMessage: ``,
      }

    case SET_MULTIACCOUNT_LINK_PENDING:
      return {
        ...state,
        setMultiAccountLinkState: `pending`,
        setUnLinkAccountStateMessage: ``,
        setMultiAccountLinkStateMessage: ``,
        errorMessage: ``,
      }

    case SET_LINKED_ACCOUNTS_FAILED:
      return {
        ...state,
        setLinkAccountState: `failed`,
        setLinkAccountStateMessage: `failed`,
        errorMessage: action.payload,
      }

    case SET_MULTIACCOUNT_LINK_FAILED:
      return {
        ...state,
        setMultiAccountLinkState: `failed`,
        setMultiAccountLinkStateMessage: `failed`,
        multiAccountErrors: action.payload.multiAccountErrors,
        statusCode: action.payload.statusCode,
      }

    case SET_LINKED_ACCOUNTS_FULFILLED:
      /* backend is sending inconsistent field names */
      const newAccounts = []
      if (isArray(action.payload.linkedAccount)) {
        each(action.payload.linkedAccount, (linkedAccount) => {
          newAccounts.push({
            ...linkedAccount,
            lob: linkedAccount.Lob,
          })
        })
      } else {
        newAccounts.push({
          ...action.payload.linkedAccount,
          lob: action.payload.linkedAccount.Lob,
        })
      }

      dedupedAccounts = uniqBy(
        [...state.linkedAccounts, ...newAccounts],
        "custAccountId",
      )

      return {
        ...state,
        setLinkAccountState: `fulfilled`,
        setLinkAccountStateMessage: `success`,
        errorMessage: ``,
        linkedAccounts: dedupedAccounts,
        // unlinkedAccounts: [...state.unlinkedAccounts.filter(s => s.custAccountId !== action.payload.custAccountId)],
      }

    case SET_MULTIACCOUNT_LINK_FULFILLED:
      const normalizeAccounts = (accounts) => {
        if (!accounts) return []

        const arr = Array.isArray(accounts) ? accounts : [accounts]

        return arr.map((acc) => ({
          ...acc,
          lob: acc?.Lob,
        }))
      }

      const newLinkedAccounts = normalizeAccounts(action.payload.linkedAccounts)
      const newPendingAccounts = normalizeAccounts(
        action.payload.pendingAccounts,
      )

      dedupedAccounts = uniqBy(
        [...state.linkedAccounts, ...newLinkedAccounts],
        "custAccountId",
      )

      dedupedPendingAccounts = uniqBy(
        [...state.pendingAccounts, ...newPendingAccounts],
        "custAccountId",
      )

      return {
        ...state,
        setMultiAccountLinkState: `fulfilled`,
        setMultiAccountLinkStateMessage: `success`,
        errorMessage: ``,
        linkedAccounts: dedupedAccounts,
        pendingAccounts: dedupedPendingAccounts,
        multiAccountErrors: action.payload.errors || {},
        numPendingAccounts: action.payload.pendingAccounts.length || 0,
      }
    case SET_UNLINKED_ACCOUNTS_PENDING:
      return {
        ...state,
        setUnLinkAccountStateMessage: `pending`,
        setLinkAccountStateMessage: ``,
        errorMessage: ``,
        setMultiAccountLinkStateMessage: ``,
        numPendingAccounts: 0,
      }

    case SET_UNLINKED_ACCOUNTS_FAILED:
      return {
        ...state,
        setUnLinkAccountStateMessage: `failed`,
        errorMessage: action.payload,
      }

    case SET_UNLINKED_ACCOUNTS_FULFILLED:
      dedupedAccounts = uniqBy(
        [
          ...state.linkedAccounts.filter(
            (s) =>
              s.custAccountId !== action.payload.linkedAccount.custAccountId,
          ),
        ],
        "custAccountId",
      )

      return {
        ...state,
        setUnLinkAccountStateMessage: `fulfilled`,
        errorMessage: ``,
        linkedAccounts: dedupedAccounts,
      }

    case HIDE_MANAGE_ACCOUNT_MESSAGE:
      return {
        ...state,
        setLinkAccountStateMessage: ``,
        setUnLinkAccountStateMessage: ``,
        errorMessage: ``,
        setMultiAccountLinkStateMessage: ``,
      }

    case UPDATE_LINKED_ACCOUNTS_FULFILLED:
      const clonedLinkedAccounts = getLinkedAccounts(state, action)
      return {
        ...state,
        updateNickNameState: `fulfilled`,
        updateNickNameStateStateMessage: `success`,
        errorMessage: ``,
        linkedAccounts: clonedLinkedAccounts,
      }

    case GET_USER_PAYMENT_STATUS_PENDING:
      return {
        ...state,
        userAccountStatus: `pending`,
      }

    case GET_USER_PAYMENT_STATUS_FAILED:
      return {
        ...state,
        userAccountStatus: `failed`,
      }

    case GET_USER_PAYMENT_STATUS_FULFILLED:
      return {
        ...state,
        userAccountStatus: `fulfilled`,
        userAccountDetails: [...action.payload.accounts],
        contactUpdate: state.contactUpdate,
        actualResponse: action.payload.actualResponse,
      }

    case RESET_DASHBOARD_FROM_GETTING_STARTED:
    case RESET_USER_ACCOUNT:
      return {
        ...initialState,
      }

    case SET_CONTACT_UPDATE_PENDING:
      return {
        ...state,
        contactUpdateStatus: `pending`,
      }

    case SET_CONTACT_UPDATE_FAILED:
      return {
        ...state,
        contactUpdateStatus: `failed`,
      }

    case SET_CONTACT_UPDATE_FULFILLED:
      return {
        ...state,
        contactUpdate: false,
        contactUpdateStatus: `fulfilled`,
      }

    case CLEAR_FIRST_TIME_USER:
      return {
        ...state,
        contactUpdate: !isEmpty(action.payload.eligibleDashboardTour),
        eligibleDashboardTour: action.payload.eligibleDashboardTour,
        eligibleTours: action.payload.eligibleTours,
      }

    case CLEAR_DASHBOARD_TOUR:
      const eligibleDashboardTour = getEligibleDashboardTour(action, state)

      return {
        ...state,
        eligibleDashboardTour,
      }

    case SET_DASHBOARD_TYPE:
      return {
        ...state,
        useNewDashboard: action.payload,
      }

    default:
      return state
  }
}

/**
 * Retrieves the eligible dashboard tour based on the provided action and state.
 * @param {Object} action - The action object.
 * @param {Object} state - The state object.
 * @returns {Array} - The filtered eligible dashboard tour.
 */
export const getEligibleDashboardTour = (action, state) =>
  action?.payload !== `selector`
    ? state?.eligibleDashboardTour?.filter((tour) => tour !== action?.payload)
    : state?.eligibleDashboardTour?.filter((tour) => tour === `dashboard`)

/**
 * Retrieves the linked accounts from the state and updates the nickname of the specified account.
 * @param {Object} state - The current state object.
 * @param {Object} action - The action object containing the payload.
 * @returns {Array} - The updated array of linked accounts.
 */
export const getLinkedAccounts = (state, action) => {
  if (!state || !action) {
    return []
  }

  const clonedLinkedAccounts = (state.linkedAccounts || []).map((account) => {
    if (account && account.custAccountId === action.payload?.custAccountId) {
      return { ...account, nickName: action.payload?.nickName }
    }
    return account
  })

  return clonedLinkedAccounts
}

/**
 * Deduplicates and merges the given accounts with the existing accounts in the state.
 * @param {Array} dedupedAccounts - The deduplicated accounts.
 * @param {Object} action - The action object.
 * @param {Object} state - The state object.
 * @returns {Array} - The deduplicated and merged accounts.
 */
export const dedupeAndMergeAccounts = (dedupedAccounts, action, state) => {
  // eslint-disable-next-line no-param-reassign
  dedupedAccounts = uniqBy(
    [...action.payload.linkedAccounts, ...state.linkedAccounts],
    "custAccountId",
  )

  // eslint-disable-next-line no-param-reassign
  dedupedAccounts = map(action.payload.linkedAccounts, (item) => {
    const updateIdx = findIndex(
      dedupedAccounts,
      (uniqAcct) =>
        get(uniqAcct, `custAccountId`, `a`) === get(item, `custAccountId`, `b`),
    )

    if (
      updateIdx > -1 &&
      get(dedupedAccounts, `[${updateIdx}].statusCode`, ``)
    ) {
      return item
    }
    return get(dedupedAccounts, `[${updateIdx}]`, ``)
  })
  return dedupedAccounts
}
